import { SerializableMap } from '../types/serializable-map';
import { UnionMap } from '../types/union-map';

// TODO: Task 2443329: Update add-ons to use Data plane SDK package when available
export type DevBoxHyperVProvisioningState = 'Creating' | 'Deleting' | 'Unknown' | 'Succeeded' | 'Failed';

export const DevBoxHyperVProvisioningState: UnionMap<DevBoxHyperVProvisioningState> = {
    Creating: 'Creating',
    Deleting: 'Deleting',
    Unknown: 'Unknown',
    Succeeded: 'Succeeded',
    Failed: 'Failed',
};

export const UbuntuJammyJellyfish = 'Ubuntu 22.04';
export const UbuntuNoble = 'Ubuntu 24.04';
export const DebianImageName = 'Debian 12 Bookworm';

export const HyperVDogfoodingProjectUrisMap: SerializableMap<string> = {
    // internal project in dogfooding R&D subscription
    'https://72f988bf-86f1-41af-91ab-2d7cd011db47-linux-devcenter.centraluseuap.devcenter.azure.com/projects/linux_dogfooding':
        UbuntuJammyJellyfish,
    // Mathworks project
    'https://99dd3a11-4348-4468-9bdd-e5072b1dc1e6-hostingdevcenterwus3.westus3.devcenter.azure.com/projects/linuxdevdoxtestingproject':
        UbuntuJammyJellyfish,
    // GM project
    'https://5de110f8-2e0f-4d45-891d-bcf2218e253d-a214143-gmit-dc.devcenter.azure.com/projects/a142978-d4-musea2-prj-devbox':
        UbuntuJammyJellyfish,
    // Novodisk project
    'https://fdfed7bd-9f6a-44a1-b694-6e39c468c150-nndevcenterpublic.westeurope.devcenter.azure.com/projects/linuxppv':
        UbuntuJammyJellyfish,
    // Unloan project
    'https://35e07416-9027-4637-ae4d-72159981338a-unl-aue-nonp-dev-dc.australiaeast.devcenter.azure.com/projects/unl-aue-dev-dc-project':
        UbuntuJammyJellyfish,
    // ATO project
    'https://00d1a6c6-8be5-4ba1-ad90-7ddf4250060e-ato-devbox-qa-dc.australiaeast.devcenter.azure.com/projects/ato-devbox-linux-qa-project':
        UbuntuJammyJellyfish,
    // EGA project
    'https://122ec050-e4e4-47e8-862a-5c4b5d574201-devcenter-prod-global-001.centralindia.devcenter.azure.com/projects/project-linuxpreview':
        UbuntuJammyJellyfish,
    // Amplify Health project
    'https://a5f82453-6b9a-445e-aa39-460d2f9c5fc2-ah-devbox-center.southeastasia.devcenter.azure.com/projects/ah-devbox-project-preview':
        UbuntuJammyJellyfish,
    // Novo Nordisk project
    'https://fdfed7bd-9f6a-44a1-b694-6e39c468c150-devbox-center.westeurope.devcenter.azure.com/projects/devbox-project':
        UbuntuJammyJellyfish,
    // Neuberger Berman project
    'https://3f06a216-e798-47d3-9b06-31482aa5a648-atr-devcloud.eastus2.devcenter.azure.com/projects/ATR-Simulated':
        UbuntuJammyJellyfish,
    // Vodafone project
    'https://68283f3b-8487-4c86-adb3-a5228f18b893-devcenter-alpha.uksouth.devcenter.azure.com/projects/prj-Proteus-NDA-Alpha':
        UbuntuJammyJellyfish,
    // Customer Success team
    'https://af1e1066-c7d3-43c9-a990-4da290b8d5b2-manualdc.centralus.devcenter.azure.com/projects/LinuxProject':
        UbuntuJammyJellyfish,
    // Nestle project 1
    'https://fb9a423a-bfe2-447c-afde-c925278d8c1e-devbox-cloudcherry-prod.switzerlandnorth.devcenter.azure.com/projects/PythonLearn':
        UbuntuJammyJellyfish,
    // Nestle project 2
    'https://fb9a423a-bfe2-447c-afde-c925278d8c1e-devbox-cloudcherry-prod.switzerlandnorth.devcenter.azure.com/projects/AITour':
        UbuntuJammyJellyfish,
    // Aveva project
    'https://2569416d-6088-464a-bbc7-34c467d20336-dc-aveva.uksouth.devcenter.azure.com/projects/dcp-aveva':
        UbuntuJammyJellyfish,
    // internal project in dogfooding R&D subscription
    'https://72f988bf-86f1-41af-91ab-2d7cd011db47-linux-devcenter.centraluseuap.devcenter.azure.com/projects/linux-debian-bookworm':
        DebianImageName,
    // internal project in dogfooding R&D subscription
    'https://72f988bf-86f1-41af-91ab-2d7cd011db47-linux-devcenter.centraluseuap.devcenter.azure.com/projects/linux-ubuntu-noble':
        UbuntuNoble,
};

export const HyperVDogfoodingInstructionsLink = 'https://aka.ms/devbox/linuxdogfooding/instructions ';

export const LinuxName = 'Linux';

export type DevBoxAddOnType = 'DevBoxHyperV' | 'DevBoxTunnel';

export const DevBoxAddOnType: UnionMap<DevBoxAddOnType> = {
    DevBoxHyperV: 'DevBoxHyperV',
    DevBoxTunnel: 'DevBoxTunnel',
};

export const DefaultDevBoxTunnelName = 'devboxtunnel-sys-default';

export const DefaultDevBoxTunnelHostingResourceName = 'Default';

// DevBox tunnel error codes
export type DevBoxTunnelErrorCode = 'DevBoxTunnelNotEnabled';

export const DevBoxTunnelErrorCode: UnionMap<DevBoxTunnelErrorCode> = {
    DevBoxTunnelNotEnabled: 'DevBoxTunnelNotEnabled',
};

// TODO: Task 2443329: Update add-status to use Data plane SDK package when available
export type DevBoxHyperVStatus = 'Unknown' | 'Starting' | 'Running' | 'Stopping' | 'Stopped';

export const DevBoxHyperVStatus: UnionMap<DevBoxHyperVStatus> = {
    Unknown: 'Unknown',
    Starting: 'Starting',
    Running: 'Running',
    Stopping: 'Stopping',
    Stopped: 'Stopped',
};

export type DevBoxAddOnActionState = 'Unknown' | 'Enabling' | 'Disabling' | 'Enabled' | 'Disabled';

export const DevBoxAddOnActionState: UnionMap<DevBoxAddOnActionState> = {
    Unknown: 'Unknown',
    Enabling: 'Enabling',
    Disabling: 'Disabling',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
};
